import { P, TextLink, theme } from '@ovotech/element-v5';
import styled from 'styled-components';

export const LinkStyled = styled(TextLink)`
  color: ${theme.color.surface.link};
  font-family: ${theme.web.font.family};
  font-size: ${theme.font.size.sm.mediaQuery.lg};
  font-style: normal;
  font-weight: 450;
  line-height: ${theme.font.lineHeight.sm.mediaQuery.sm};
  letter-spacing: ${theme.font.letterSpacing.sm.mediaQuery.sm};
  text-decoration-line: underline;
  cursor: pointer;
`;

export const PStyled = styled(P)`
  color: ${theme.color.surface.onSurface};
  font-family: ${theme.web.font.family};
  font-size: ${theme.font.size.md.mediaQuery.sm};
  font-style: normal;
  font-weight: ${theme.font.weight.bold};
  line-height: ${theme.font.lineHeight.md.mediaQuery.sm};
  letter-spacing: ${theme.font.letterSpacing.md.mediaQuery.sm};
  white-space: nowrap;
`;

export const MilesText = styled(P)`
  white-space: nowrap;
  text-align: left;

  ${({ theme }) => theme.mediaQueries.mediumAndUp} {
    text-align: right;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.space['200']} ${theme.space['400']};
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
